import type { ReactNode } from "react";
import { Inbox } from "lucide-react";
import { cn } from "../utils/cx.js";

export interface EmptyProps {
  description?: ReactNode;
  image?: ReactNode;
  className?: string;
  children?: ReactNode;
}

export function Empty({ description, image, className, children }: EmptyProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-3 py-10 text-center text-muted-foreground",
        className,
      )}
    >
      {image ?? <Inbox className="size-10 opacity-40" strokeWidth={1.5} />}
      {description != null && <div className="text-sm">{description}</div>}
      {children}
    </div>
  );
}
